import { Reflect } from "@workcanvas/reflect/client";
import { M } from "shared/datamodel/mutators";
import { useState, useEffect } from "react";
import { getIcon, CacheEntry } from "./icon-fetch-and-cache";

export function useNounIcon(id: string, rep?: Reflect<M>) {
  const [result, setResult] = useState<CacheEntry | undefined>();
  useEffect(() => {
    getIcon(id, setResult, rep);
  }, [id, rep]);
  return result;
}
